import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThemeState, ThemeId } from '../../types/theme';
import { availableThemes, defaultTheme } from '../../config/themes';

// Get default theme from .env or fallback to 'default'
const defaultThemeId = (process.env.REACT_APP_DEFAULT_THEME as ThemeId) || 'default';
const savePreference = process.env.REACT_APP_SAVE_THEME_PREFERENCE !== 'false';

const initialState: ThemeState = {
  currentTheme: savePreference
    ? (localStorage.getItem('selectedTheme') as ThemeId) || defaultThemeId
    : defaultThemeId,
  availableThemes,
  customThemes: [],
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeId>) => {
      state.currentTheme = action.payload;
      if (savePreference) {
        localStorage.setItem('selectedTheme', action.payload);
      }
    },
    resetTheme: (state) => {
      state.currentTheme = defaultThemeId;
      if (savePreference) {
        localStorage.removeItem('selectedTheme');
      }
    },
    addCustomTheme: (state, action: PayloadAction<any>) => {
      state.customThemes.push(action.payload);
    },
    removeCustomTheme: (state, action: PayloadAction<string>) => {
      state.customThemes = state.customThemes.filter(
        theme => theme.id !== action.payload
      );
    },
  },
});

export const {
  setTheme,
  resetTheme,
  addCustomTheme,
  removeCustomTheme,
} = themeSlice.actions;

export default themeSlice.reducer;